import React from 'react';
import PropTypes from 'prop-types';

import {
  TextInput,
} from '../../../fragments/forms';


export default class PubMedID extends React.Component {

  static propTypes = {
    reference: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  get allMessage() {
    const {reference, showError} = this.props;

    return reference.messages('medlineId', showError);
  }

  render() {
    const {reference} = this.props;
    const {allMessage} = this;

    if (!reference.medlineId) {
      return null;
    }

    return (
      <TextInput
       name="medlineId"
       label="Medline ID"
       readOnly={true}
       value={reference.medlineId}
       onChange={() => {}}
       messages={allMessage} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-edit/pubmed-id.js